const riot = require('riot');

riot.tag2('tooltip-users', '<div class="w110 bg-dark_blur p8 rounded-8 font-lato fs12 text-white box-shadow-primary" ref="tooltip" show="{users &amp;&amp; users.length}"> <div data-is="module-users" limit="{opts.limit}" users="{users}"></div> </div>', '', '', function(opts) {
    this.on('mount', () => {
      this.users = opts.users;
      this.update();
    });
});